import { MenuItem, MenuItemProps } from '@chakra-ui/react'

import { ACTIONS, ActionKind, DESTRUCTIVE_ACTIONS } from './actions'

export interface IActionMenuItemProps extends Omit<MenuItemProps, 'icon' | 'children'> {
  action: ActionKind
  label?: string
}

/**
 * Item de menu para ações CRUD dentro de um `<Menu>`.
 * Usa a prop `icon` nativa do Chakra (espaçamento e alinhamento corretos)
 * e destaca ações destrutivas em vermelho automaticamente.
 */
export default function ActionMenuItem({ action, label, ...rest }: IActionMenuItemProps) {
  const config = ACTIONS[action]
  const text = label ?? config.label

  return (
    <MenuItem icon={config.icon} color={DESTRUCTIVE_ACTIONS.includes(action) ? 'red.500' : undefined} {...rest}>
      {text}
    </MenuItem>
  )
}
